import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs'
const Sobre = ({ children, page }) => {
  return (
    <>
      <Breadcrumbs
        pages={[
          {
            title: page.title,
            url: page.slug
          }
        ]}
      />
      <div className='page-container'>
        {children}
      </div>
    </>
  )
}

export default Sobre
